import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M20.58 9.55c.13 0 .19 0 .27.1.44.49 1.88 2.21 2.28 2.68a.16.16 0 010 .21 51.41 51.41 0 00-7.93 7.61 92.18 92.18 0 0113.83-4V12L16 2 3 12v4.57a92.37 92.37 0 0117.58-7.02z"/><path d="M10 26.86a.22.22 0 01-.28 0L7.3 24c-.07-.08-.07-.12 0-.25a45.52 45.52 0 018.14-8.66s0-.06 0 0A108.81 108.81 0 003 20.37V30h26v-9.26c-3.55.59-14.16 3.68-19 6.12z"/>';
export var ZillowLogoSVG = function ZillowLogoSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ZillowLogoSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ZillowLogoSVG);